<template>
  <el-dialog
    title="修改列表"
    class="newDialog"
    append-to-body
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="500px"
    >
    <div class="AI_edit_dialog" v-loading="loading">
      <div class="AI_edit_dialog-input">
        <el-form>
          <el-form-item label="修改值:">
            <el-input v-model="editValue" size="small" placeholder="请输入修改值" style="width: 380px;" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="AI_edit_dialog-footer">
        <acc-btn text="取消" type="2" @click="dialogVisible=false" size="mini"></acc-btn>
        <acc-btn @click="handleEventSave" size="mini"></acc-btn>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible:false,
        loading:false,
        editValue:"",
      }
    },
    methods:{
       handleEventSave() {
         this.loading = true;
          this.$emit('getEditValue',this.editValue)
       }
    }
  }
</script>

<style lang='less'>
  .AI_edit_dialog {
    padding: 0 30px 30px;
    &-input {
    }
    &-footer {
      margin-top: 30px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AIImport/editDialog.vue